export const isValidNumber = (number) => {
    // numbers only regular expression /^[0-9]*$/
    if( /^[0-9]*$/.test (number)){
        return true
    }
    else{
        return false
    }
}